// src/v3/ui/_common/components/ui/empty-state.tsx

import type { ReactNode } from "react";
import { Inbox } from "lucide-react";
import { cn } from "../../lib/utils";

export function EmptyState({
  message,
  className,
  children,
}: {
  message: string;
  className?: string;
  children?: ReactNode;
}) {
  return (
    <div className={cn("flex flex-col items-center justify-center p-8", className)}>
      <Inbox className="mb-2 h-8 w-8 text-muted-foreground" />
      <p className="text-sm text-muted-foreground">{message}</p>
      {children}
    </div>
  );
}

